<template>
  <q-page :padding="!user.id && $q.screen.gt.xs" class="docs-table" :style-fn="myTweak">
    <q-table
        :title="user.id ? 'Referrals' : $t('users.menu.list')"
        ref="table"
        :data="serverData"
        :columns="columns"
        :filter="filter"
        row-key="id"
        :pagination.sync="serverPagination"
        :visible-columns="visibleColumns"
        :loading="loading"
        :selection="selection"
        :selected.sync="selectedRows"
        :rows-per-page-options="[15, 50, 100, 250, 500]"
        class="card-shadow"
        @request="all"
    >
      <template v-slot:top-selection="props" v-if="$auth.can('users.edit')">
        <q-btn color="primary" outline icon="fa fa-envelope" :label="$t('email')" class="q-mr-sm" @click="sendEmail"/>
        <q-btn color="pink-5" outline icon="fa fa-times" class="q-mr-sm" @click="selectedRows = []"/>
      </template>

      <template v-slot:top-right="props">
        <q-btn
            outline
            :label="$t('users.menu.create')"
            icon="fa fa-plus"
            color="positive"
            class="q-mr-sm"
            v-if="$auth.can('users.create') && !user.id"
            @click="$router.push({name: 'users.create'})"
        />
        <q-btn outline :label="$t('refresh')" icon="fas fa-sync" color="primary" class="q-mr-sm"
               @click="all({pagination: serverPagination, filter})" :loading="loading">
          <template v-slot:loading>
            <q-spinner-dots />
          </template>
        </q-btn>
        <q-btn
            :outline="!is_filtered"
            color="black"
            :label="is_filtered ? 'Filtered' : 'Filter'"
            class="q-mr-sm"
            icon="fa fa-filter"
        >
            <q-menu @hide="all({ pagination: serverPagination, filter})">
                <div class="row q-pa-md q-col-gutter-md" style="width: 300px">
                    <div class="col-12">
                          <q-input
                              :value="date_range.from ? date_range.from + ' | ' + date_range.to : ''"
                              class="full-width q-mr-sm"
                              color="primary"
                              label="Registered date"
                              readonly
                          >
                              <template v-slot:append v-if="date_range.from" >
                                  <q-icon
                                      name="cancel"
                                      @click.stop="removeDateRangeFilter"
                                      class="cursor-pointer"
                                  />
                              </template>
                              <template v-slot:prepend>
                                  <q-icon name="event" class="cursor-pointer">
                                      <q-popup-proxy
                                          ref="qDateProxy"
                                          transition-show="scale"
                                          transition-hide="scale"
                                      >
                                          <q-date
                                              v-model="selecting_range"
                                              range
                                              mask="YYYY-MM-DD"
                                          >
                                              <div class="row items-center justify-end">
                                                  <q-btn v-close-popup label="Set" color="primary" flat />
                                              </div>
                                          </q-date>
                                      </q-popup-proxy>
                                  </q-icon>
                              </template>
                          </q-input>
                      </div> <!-- Date Range -->
                    <div class="col-12">
                        <q-select
                            v-model="status"
                            label="Verification status"
                            clearable
                            dense
                            :options="verification_statuses"
                            color="primary"
                            class="full-width"
                        />
                    </div> <!-- Verification status -->
                    <div class="col-12">
                        <q-select
                            v-model="ramp"
                            label="Ramps"
                            clearable
                            dense
                            options-dense
                            :options="ramps"
                            style="min-width: 150px"
                            color="primary"
                        />
                    </div> <!-- Ramps -->
                    <div class="col-12">
                        <q-select
                            v-model="country"
                            label="Country"
                            clearable
                            dense
                            options-dense
                            option-value="id"
                            option-label="name"
                            emit-value
                            map-options
                            :options="real_countries"
                            style="min-width: 150px"
                            color="primary"
                        >
                            <template v-slot:option="scope">
                                <q-item
                                    v-bind="scope.itemProps"
                                    v-on="scope.itemEvents"
                                    style="border-bottom:1px solid #999"
                                >
                                    <q-item-section avatar>
                                        <q-icon :name="scope.opt.acronym" size="xs" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label>{{scope.opt.name}}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div> <!-- Country -->
                    <div class="col-12">
                        <div class="row">
                            <q-checkbox v-model="filterByOrder" label="Order count" color="primary" class="col-6" />
                            <q-select
                                v-model="orderFilter.operator"
                                option-value="value"
                                option-label="label"
                                emit-value
                                map-options
                                dense
                                outlined
                                :options="orderFilterOperators"
                                color="primary"
                                class="col-4"
                                v-if="filterByOrder"
                            />
                            <q-input
                                class="col-2"
                                outlined
                                v-model="orderFilter.count"
                                dense
                                type="number"
                                v-if="filterByOrder"
                            />
                        </div>
                    </div> <!-- Order -->
                    <div class="col-12">
                        <q-item class="q-px-none">
                            <q-item-section>
                                <q-item-label>Has mobile?</q-item-label>
                            </q-item-section>
                            <q-item-section side >
                                <q-toggle
                                    color="primary"
                                    v-model="hasMobile"
                                    val="mobile"
                                    checked-icon="fa fa-check"
                                    unchecked-icon="fa fa-times"
                                    toggle-indeterminate
                                    @input="all({ pagination: serverPagination, filter})"
                                />
                            </q-item-section>
                        </q-item>
                    </div> <!-- Has Mobile -->
                </div>
            </q-menu>
        </q-btn>
        <q-input dense debounce="300" v-model="filter" :placeholder="$t('search')" class="q-mr-sm" color="primary">
          <template v-slot:prepend>
            <q-icon name="search" />
          </template>
        </q-input>
        <q-select
            v-model="visibleColumns"
            multiple
            dense
            options-dense
            :display-value="$q.lang.table.columns"
            emit-value
            map-options
            :options="columns"
            option-value="name"
            style="min-width: 150px;margin-right:10px"
            color="primary"
        />
      </template>

      <template v-slot:header="props">
          <q-tr :props="props">
              <q-th auto-width />
              <q-th auto-width v-if="selection !== 'none'">
                  <q-checkbox dense v-model="props.selected" color="primary" />
              </q-th>
              <q-th
                  v-for="col in props.cols"
                  :key="col.name"
                  :props="props"
              >
                  <span>{{ col.label }}</span>
              </q-th>
          </q-tr>
      </template>

      <!-- START CUSTOM COLUMNS -->
      <template v-slot:body="props">
        <q-tr :props="props" :statement="props.row.currentIdentityStatus = identityStates.find(item => item.name === props.row.identity)">
          <q-td auto-width>
              <q-btn size="sm" color="primary" round dense @click="details(props)" :icon="props.expand ? 'fa fa-angle-up' : 'fa fa-angle-down'" />
          </q-td>
          <q-td auto-width v-if="selection !== 'none'">
            <q-checkbox dense v-model="props.selected" color="primary" />
          </q-td>
          <q-td key="id" :props="props">{{ props.row.id }}</q-td>
          <q-td key="first_name" :props="props">
              <q-icon size="14px" color="blue" name="fa fa-male" v-if="props.row.gender === 'M'"/>
              <q-icon size="14px" color="pink" name="fa fa-female" v-else-if="props.row.gender === 'F'"/>
              <q-icon size="14px" color="purple" name="fa fa-genderless" v-else-if="props.row.gender === 'O'"/>
              {{ props.row.first_name }}
              <q-popup-edit
                  v-model="props.row.gender"
                  buttons
                  @save="(val, initialValue) => editInline(val, initialValue, props.row, 'first_name')"
              >
                  <template v-slot="{ initialValue, value, emitValue, validate, set, cancel }">
                      <q-select
                          v-model="props.row.gender"
                          :options="genders"
                          fill-input
                          option-value="value"
                          option-label="label"
                          clearable
                          emit-value
                          map-options
                          :label="$t('users.table_titles.gender')"
                          color="primary"
                          :value="props.row.gender"
                      >
                          <template v-slot:option="scope">
                              <q-item
                                  v-bind="scope.itemProps"
                                  v-on="scope.itemEvents"
                              >
                                  <q-item-section>
                                      <q-item-label>{{scope.opt.label}}</q-item-label>
                                  </q-item-section>
                              </q-item>
                          </template>
                      </q-select>
                  </template>
              </q-popup-edit>
          </q-td>
          <q-td key="middle_name" :props="props">{{ props.row.middle_name }}</q-td>
          <q-td key="last_name" :props="props">{{ props.row.last_name }}</q-td>
          <q-td key="country" :props="props">
            <div v-if="props.row.country"><q-icon :name="props.row.country.acronym" size="18px"/> {{ props.row.country.name }}</div>
          </q-td>
          <q-td key="date_of_birth" :props="props">{{ props.row.date_of_birth }}</q-td>
          <q-td key="introducer" :props="props">
            <div v-if="props.row.introducer">
              {{props.row.introducer.name}}
              <q-btn icon="fa fa-link" size="xs" color="info" round flat @click="$router.push('/users?q='+props.row.introducer.email)" v-if="$auth.can('users.list')"/>
            </div>
            <div v-else>-</div>
          </q-td>
          <q-td key="role" :props="props">
              <div v-if="props.row.role !== '-' || !$auth.can('users.edit')">
                  {{props.row.role}}
              </div>
            <div v-else>
                <q-btn outline rounded dense no-caps color="primary" @click="makeSure(props.row)" label="Grant Additional Ramps" v-if="selectedRowToBeGranted !== props.row.id" />
                <q-btn outline rounded dense no-caps color="pink" label="Click to confirm" @click="grantAdditionalRamps(props.row)" :loading="grantLoading" v-else/>
            </div>
          </q-td>
          <q-td key="mobile" :props="props">
            <div v-if="props.row.mobile">
                <q-btn flat round dense size="sm" color="info" icon="fab fa-telegram" @click.native="openURL('https://t.me/+'+ props.row.calling_code + props.row.mobile)" v-if="$auth.can('users.contactable')" />&nbsp;
                <q-btn flat round dense size="sm" color="green" icon="fab fa-whatsapp" @click.native="openURL('https://wa.me/'+ props.row.calling_code + props.row.mobile)" v-if="$auth.can('users.contactable')"/>&nbsp;
                {{ '+' + props.row.calling_code + props.row.mobile}}
            </div>
          </q-td>
          <q-td key="email" :props="props">
              <q-btn round outline size="sm" color="primary" icon="fa fa-envelope" @click="openEmailForm(props.row)" v-if="$auth.can('users.contactable')"/>&nbsp;
              <q-icon color="light-green" name="fa fa-check" v-if="props.row.is_email_verified === 'verified'"/>
              <q-icon color="orange" name="fa fa-hourglass" v-else/>
              <span>&nbsp;
                  <q-btn flat dense
                         :label="props.row.email"
                         @click.native="openURL('mailto:'+props.row.email)"
                         no-caps
                  />
              </span>
              <q-btn
                  round
                  flat
                  color="primary"
                  icon="far fa-copy"
                  @success="copied('Email copied!')"
                  v-clipboard="props.row.email"
                  dense
              />
          </q-td>
          <q-td key="address" :props="props">
              {{props.row.address}}
          </q-td>
          <q-td key="identity" :props="props">
              <q-btn-dropdown
                  outline
                  dense
                  :color="props.row.currentIdentityStatus.color"
                  :label="props.row.currentIdentityStatus.label"
                  :icon="props.row.currentIdentityStatus.icon"
                  v-if="$auth.can('users.verification')"
              >
                  <q-list dense>
                      <q-item
                          clickable
                          v-close-popup
                          class="text-blue"
                          @click="updateAuthenticationStatus('reset', props.row.identity, props.row, 'identity')"
                          v-if="['verified','reviewed','failed','rejected'].includes(props.row.identity)"
                      >
                          <q-item-section avatar>
                              <q-icon name="fa fa-redo-alt" color="blue" size="xs" />
                          </q-item-section>
                          <q-item-section>Reset</q-item-section>
                      </q-item>

                      <q-item
                          clickable
                          v-close-popup
                          class="text-positive"
                          @click="updateAuthenticationStatus('verify', props.row.identity, props.row, 'identity')"
                          v-if="['none', 'reviewed', 'rejected', 'hold'].includes(props.row.identity)"
                      >
                          <q-item-section avatar>
                              <q-icon name="fa fa-check" color="positive" size="xs"/>
                          </q-item-section>
                          <q-item-section>Approve</q-item-section>
                      </q-item>

                      <q-item
                          clickable
                          v-close-popup
                          class="text-black"
                          @click="updateAuthenticationStatus('review', props.row.identity, props.row, 'identity')"
                          v-if="! ['failed','reviewed'].includes(props.row.identity)"
                      >
                          <q-item-section avatar>
                              <q-icon name="fa fa-street-view" color="black" size="xs"/>
                          </q-item-section>
                          <q-item-section>Review</q-item-section>
                      </q-item>

                      <q-item
                          clickable
                          v-close-popup
                          class="text-primary"
                          @click="updateAuthenticationStatus('hold', props.row.identity, props.row, 'identity')"
                          v-if="! ['none','failed', 'hold'].includes(props.row.identity)"
                      >
                          <q-item-section avatar>
                              <q-icon name="fa fa-circle-pause" color="primary" size="xs"/>
                          </q-item-section>
                          <q-item-section>Hold</q-item-section>
                      </q-item>

                      <q-item
                          clickable
                          v-close-popup
                          class="text-red"
                          @click="updateAuthenticationStatus('reject', props.row.identity, props.row, 'identity')"
                          v-if="! ['rejected'].includes(props.row.identity)"
                      >
                          <q-item-section avatar>
                              <q-icon name="fa fa-times" color="red" size="xs"/>
                          </q-item-section>
                          <q-item-section>Reject</q-item-section>
                      </q-item>

                      <q-separator inset />

                      <q-item
                          clickable
                          v-close-popup
                          class="text-blue"
                          @click="displaySetAction(props.row)"
                          v-if="['reviewed', 'hold', 'rejected'].includes(props.row.identity)"
                      >
                          <q-item-section avatar>
                              <q-icon name="fa fa-comment" color="primary" size="xs" />
                          </q-item-section>
                          <q-item-section>Set Action</q-item-section>
                      </q-item>

                      <q-separator inset />

                      <q-item
                          clickable
                          v-close-popup
                          class="text-black"
                          @click="openURL(props.row.aply_id_url)"
                          v-if="['reviewed','failed'].includes(props.row.identity)"
                      >
                          <q-item-section avatar>
                              <q-icon name="img:/custom_icons/aplyid.png" color="black" size="xs"/>
                          </q-item-section>
                          <q-item-section>View in AplyId</q-item-section>
                      </q-item>
                  </q-list>
              </q-btn-dropdown>
              <div v-else :class="'text-' + props.row.currentIdentityStatus.color">{{ props.row.currentIdentityStatus.label }}</div>
          </q-td>
          <q-td key="ecdd" :props="props">
              <q-toggle
                  v-model="props.row.ecdd"
                  checked-icon="fa fa-check"
                  color="green"
                  @input="editInline($event, props.row.ecdd, props.row, 'ecdd')"
                  unchecked-icon="fa fa-times"
                  :disabled="loading"
              />
          </q-td>
          <q-td key="is_blocked" :props="props">
            <q-toggle
                  v-model="props.row.is_blocked"
                  checked-icon="fa fa-check"
                  color="red"
                  @input="editInline($event, props.row.is_blocked, props.row, 'is_blocked')"
                  unchecked-icon="fa fa-times"
                  :disabled="loading"
                />
          </q-td>
          <q-td key="account_type" :props="props">
                <div v-if="props.row.account_type === 'personal'">
                    <q-icon name="fa fa-male"/> Personal
                </div>
                <div v-if="props.row.account_type === 'business'">
                    <q-icon name="fa fa-building"/> Business
                </div>
            </q-td>
          <q-td key="created_at" :props="props">
            <div style="direction:ltr">{{props.row.created_at}}</div>
          </q-td>
          <q-td key="last_login_at" :props="props">
            <div style="direction:ltr">{{props.row.last_login_at}}</div>
          </q-td>
          <q-td key="setting" :props="props">
            <q-btn flat round size="sm" :color="props.row.notes_count ? 'primary' : 'grey'" icon="fa fa-note-sticky" @click="openNotes(props.row)" v-if="$auth.can('users.notes')" />&nbsp;
            <q-btn flat round size="sm" :color="props.row.id_document_valid ? 'primary' : 'grey'" icon="fa fa-id-card" @click="openIdDocument(props.row)" v-if="$auth.can('users.edit')"/>&nbsp;
            <q-btn flat round size="sm" :color="!!props.row.profile_photo ? 'primary' : 'grey'" icon="fa fa-image" @click="openImageAttachment(props.row)" v-if="$auth.can('users.edit')"/>&nbsp;
            <q-btn round size="sm" color="orange" icon="fa fa-edit" @click="edit(props.row)" v-if="$auth.can('users.edit')"/>&nbsp;
            <q-btn round size="sm" color="red" icon="fa fa-trash" @click="deleteRow(props.row)" v-if="$auth.can('users.edit')"/>
          </q-td>
        </q-tr>
        <q-tr v-show="props.expand" :props="props" transition-show="jump-down" transition-hide="jump-up">
          <q-td colspan="100%">
            <user-details :user="props.row" v-if="props.expand"/>
          </q-td>
        </q-tr>
      </template>
      <!-- END CUSTOM COLUMNS -->
    </q-table>

    <email-modal
        v-model="displayEmailForm"
        :user-id="selectedRow.id"
        :content="selectedRow"
        v-if="$auth.can('users.contactable') && selectedRow.id"
    />

    <bulk-email-modal
        v-model="displayBulkEmailForm"
        :recipients="selectedRows"
        v-if="$auth.can('users.contactable')"
    />

    <id-document-dialog
        :user-id="selectedRow.id"
        v-model="displayIdDocumentDialog"
        :user-data="selectedRow"
        :key="refreshIdDocumentKey"
        v-if="$auth.can('users.edit') && selectedRow.id"
    />

    <notes-dialog
        v-model="displayNotesDialog"
        :noteable-id="selectedRow.id"
        noteable-type="users"
        :dialog-title="`Notes: ${selectedRow.email}`"
        v-if="$auth.can('users.notes') && selectedRow.id"
    />

    <user-image-dialog
        v-model="displayImageAttachmentDialog"
        :user-id="selectedRow.id"
        :user-data="selectedRow"
        v-if="$auth.can('users.edit') && selectedRow.id"
        :key="refreshImageAttachmentKey"
        @saved="profilePhotoStored"
        @deleted="profilePhotoDeleted"
    />

    <set-action-dialog
        v-model="displaySetActionDialog"
        :user-id="selectedRow.id"
        :status="selectedRow.identity"
        @submit="setAction"
        style="width: 450px"
    />
  </q-page>
</template>

<script>
  import User from '../models/User.js'
  import { openURL } from 'quasar'
  import UserDetails from "./details/UserDetails"
  import EmailModal from "../components/EmailModal"
  import BulkEmailModal from "../components/BulkEmailModal"
  import IdDocumentDialog from "../components/id-document/IdDocumentDialog"
  import UserImageDialog from "../components/user-image/UserImageDialog.vue"
  import {mapActions, mapGetters} from 'vuex'
  import NotesDialog from "Modules/Note/resources/components/NotesDialog.vue"
  import SetActionDialog from "../components/action/SetActionDialog.vue"
  export default {
    name: 'UsersList',
    props: {
      user: {
        type: Object,
        default: () => ({})
      },
      filterByEmail: {
        type: String,
        required: false
      }
    },
    computed: {
      ...mapGetters(['exchange_rates', 'real_countries']),
      columns() {
        let columns = [
          {name: 'id', required: true, label: this.$t('users.table_titles.id'), align: 'left', field: 'id', sortable: true},
          {name: 'first_name', label: this.$t('users.table_titles.first_name'), align: 'left', field: 'first_name', sortable: true},
          {name: 'middle_name', label: this.$t('users.table_titles.middle_name'), align: 'left', field: 'middle_name', sortable: true},
          {name: 'last_name', label: this.$t('users.table_titles.last_name'), align: 'left', field: 'last_name', sortable: true},
          {name: 'country', label: this.$t('users.table_titles.country'), align: 'left', field: 'country', sortable: true},
          {name: 'date_of_birth', label: this.$t('users.table_titles.date_of_birth'), align: 'left', field: 'date_of_birth', sortable: true},
          {name: 'introducer', label: this.$t('users.table_titles.introducer'), align: 'left', field: 'introducer', sortable: false},
          {name: 'role', label: this.$t('users.table_titles.acl'), align: 'left', field: 'role', sortable: false, classes: 'ellipsis', style: 'max-width: 180px', headerStyle: 'max-width: 180px'},
          {name: 'mobile', label: this.$t('users.table_titles.mobile'), align: 'center', field: 'mobile', sortable: false, style: 'direction:ltr'},
          {name: 'email', label: this.$t('users.table_titles.email'), align: 'left', field: 'email', sortable: false},
          {name: 'address', label: this.$t('users.table_titles.address'), align: 'left', field: 'address', sortable: false},
          {name: 'identity', label: this.$t('users.table_titles.verify_identity'), align: 'center', field: 'identity', sortable: false},
          {name: 'ecdd', label: this.$t('users.table_titles.ecdd'), align: 'center', field: 'ecdd', sortable: true},
          {name: 'is_blocked', label: this.$t('users.table_titles.is_blocked'), align: 'center', field: 'is_blocked', sortable: true},
          {name: 'account_type', label: this.$t('users.table_titles.account_type'), align: 'left', field: 'account_type', sortable: true},
          {name: 'created_at', label: this.$t('users.table_titles.registered_at'), align: 'center', field: 'created_at', sortable: true},
          {name: 'last_login_at', label: this.$t('users.table_titles.last_login_at'), align: 'center', field: 'last_login_at', sortable: true},
        ]

        // add Edit/Delete column just if the user has appropriate permission
        if(this.$auth.can('users.edit') || this.$auth.can('users.notes')) {
          let title = this.$auth.can('users.edit') ? this.$t('users.table_titles.setting') : this.$t('users.table_titles.notes')
          this.selection = 'multiple'
          this.visibleColumns.push('setting')
          columns.push({name: 'setting', align: 'center', label: title, sortable: false, field: 'setting'})
        }

        return columns
      },
      selecting_range: {
        get: function() {
           return this.date_range
        },
        set: function(value) {
           if(value && typeof value === 'string') {
               this.date_range = {from: value, to: value}
           } else if(value && typeof value === 'object' && value.from) {
               this.date_range = value
           } else {
              this.date_range = {from: '', to: ''}
           }
        }
      },
      is_filtered() {
        return this.date_range.from || this.status || this.filterByOrder || this.ramp || this.hasMobile !== null || this.country !== null
      },
      ramps() {
        return this.exchange_rates.map(rate => {return rate.from.acronym + '-' + rate.to.acronym})
      },
      filterQueryString() {
          let user_id = `user_id=${this.user.id ? this.user.id + '&load=referrals&' : '' }`
          let date_range = `date_range=${this.date_range.from},${this.date_range.to}`
          let status = `status=${this.status !== null ? this.status.toLowerCase(): ''}`
          let orderNumber = this.filterByOrder ? `order_count_operator=${this.orderFilter.operator}&order_count=${this.orderFilter.count}` : ''
          let ramp = `ramp=${this.ramp !== null ? this.ramp : ''}`
          let mobile = `mobile=${this.hasMobile !== null ? this.hasMobile : ''}`
          let country = `country=${this.country !== null ? this.country : ''}`

          return `${user_id}&${date_range}&${status}&${orderNumber}&${ramp}&${mobile}&${country}`
      },
    },
    data: () => ({
      separator: 'horizontal',
      filter: '',
      loading: false,
      loading_countries: false,
      serverPagination: {
        page: 1,
        sortBy: 'id',
        rowsPerPage: 50,
        descending: true,
        rowsNumber: 10 // specifying this determines pagination is server-side
      },
      visibleColumns: ['id', 'first_name', 'last_name', 'country', 'mobile', 'email', 'identity', 'setting'],
      serverData: [],
      selection: 'none',
      selectedRows: [],
      displayChatBox: false,
      maximizedToggle: true,
      dialogTitle: '',
      lastRecordChanged: null,
      identityStates: [
          {name:'none', label: 'New', icon: 'fa fa-user', color: 'grey'},
          {name:'verified', label: 'Verified', icon: 'fa fa-check', color: 'positive'},
          {name:'failed', label: 'Failed', icon: 'fa fa-times', color: 'red'},
          {name:'reviewed', label: 'In Review', icon: 'fa fa-street-view', color: 'black'},
          {name:'hold', label: 'Hold', icon: 'fa fa-circle-pause', color: 'primary'},
          {name:'rejected', label: 'Rejected', icon: 'fa fa-times', color: 'red'},
      ],
      displayEmailForm: false,
      displayBulkEmailForm: false,
      selectedRow: {
          id: 0
      },
      date_range: {from:'', to:''},
      status: '',
      initStatus: '',
      verification_statuses: ['Completed', 'Needs action', 'In review', 'Hold'],
      ramp: '',
      country: null,
      selectedRowToBeGranted: undefined,
      grantLoading: false,
      displayNotesDialog: false,
      displayIdDocumentDialog: false,
      displaySetActionDialog: false,
      refreshIdDocumentKey: Math.floor(Math.random() * 1000),
      refreshNotesKey: Math.floor(Math.random() * 1000),
      displayImageAttachmentDialog: false,
      refreshImageAttachmentKey: Math.floor(Math.random() * 1000),
      hasMobile: null,
      filterByOrder: false,
      orderFilterOperators: [
          {label: '=', value: '='},
          {label: '>=', value: '>='},
          {label: '<=', value: '<='},
      ],
      orderFilter: {
          operator: '>=',
          count: 0
      },
      genders: [
          {label: 'Male', value: 'M'},
          {label: 'Female', value: 'F'},
          {label: 'Other', value: 'O'},
      ]
    }),
    methods: {
      ...mapActions(['set_countries']),
      all({pagination, filter}) {
        this.loading = true
        User.all(`${this.filterQueryString}&sort=${pagination.sortBy}%7C${pagination.descending ? 'desc' : 'asc'}&page=${pagination.page}&per_page=${pagination.rowsPerPage}&filter=${filter}`, ({data, meta}) => {
          this.serverPagination = pagination
          // we also set (or update) rowsNumber
          this.serverPagination.rowsNumber = meta.total
          this.serverData = data
          this.loading = false
        }).catch(error => {
          this.$q.notify({
            message: error.data.error,
            color: 'negative',
            icon: 'fa fa-exclamation-triangle'
          })
          this.loading = false
        })
      },
      edit(value) {
        this.$router.push({name: 'users.edit', params: {id: value.id}})
      },
      editInline(val, initVal, row, col) {
          if (col !== 'first_name') {
              row[col] = val
          }
          this.loading = true
          new User({
              id: row.id,
              ecdd: col === 'ecdd' ? (val ? 1 : 0) : undefined,
              is_blocked: col === 'is_blocked' ? (val ? 1 : 0) : undefined,
              gender: col === 'first_name' ? val : undefined,
          }).updateInline((data) => {
              for (let field in data) {
                  row[field] = data[field]
              }
              this.loading = false
          }).catch(({data}) => {
              row[col] = initVal
              this.loading = false
              this.$q.notify({
                  message: `An error has occurred`,
                  color: 'negative',
                  icon: 'fa fa-exclamation-triangle'
              })
          })
      },
      deleteRow(row) {
        this.selectedRows.push(row);
        this.deleteRows();
      },
      deleteRows() {
        this.$q.dialog({
          title: 'Delete information',
          message: 'Are you sure to delete information?',
          ok: 'Yes',
          cancel: 'No'
        }).onOk(() => {
          this.$q.loading.show()
          this.selectedRows.map((row) => {
            let user = new User({id: row.id});
            user.destroy(() => {
              this.serverData = this.serverData.filter(record => record.id !== row.id);
              this.selectedRows = this.selectedRows.filter(member => member.id !== row.id);
              if(!this.selectedRows.length){
                this.$q.loading.hide()
              }
            }).catch(({data}) => {
              this.$q.loading.hide()
            })
          });
        }).onCancel(() => {
          this.$q.loading.hide()
        })
      },
      sendEmail() {
          this.displayBulkEmailForm = true
      },
      details(props) {
        props.expand = !props.expand
      },
      myTweak (offset) {
        return { minHeight: offset ? `calc(35vh - ${offset}px)` : '35vh' }
      },
      removeDateRangeFilter() {
          this.date_range = {from: '', to: ''}
          this.all({
              pagination: this.serverPagination,
              filter: this.filter
          })
      },
      updateAuthenticationStatus(val, initVal, row, col) {
          this.initStatus = initVal
          const status = val === 'verify' ? 'Approve' : val.ucfirst()
          this.$q.dialog({
              title: 'Verification: ' + status,
              message: 'Are you sure?',
              cancel: true,
              persistent: true
          }).onOk(() => {
              this.loading = true
              new User({
                  id: row.id,
                  status: val,
              }).updateAuthenticationStatus((status) => {
                  row['identity'] = status
                  if (! ['verified'].includes(status)) {
                      this.displaySetAction(row)
                  }
                  this.loading = false
              }).catch((response) => {
                  row[col] = initVal
                  this.loading = false
                  let message = `An error has occurred`
                  switch(response.status) {
                      case 422:
                          message = response.data.errors.country
                  }
                  this.$q.notify({
                      message: message,
                      color: 'negative',
                      icon: 'fa fa-exclamation-triangle'
                  })
              })
          })
      },
      displaySetAction(row) {
          this.displaySetActionDialog = true
          this.selectedRow = row
      },
      setAction({action, userId, status}) {
          this.loading = true
          new User({
              id: userId,
              action: action,
              status: status,
          }).setAction(() => {
              this.loading = false
              this.$q.notify({
                  message: `Action set successfully!`,
              })
          }).catch(({error}) => {
              this.loading = false
              this.$q.notify({
                  message: `An error has occurred`,
                  color: 'negative',
                  icon: 'fa fa-exclamation-triangle'
              })
          })
      },
      copied(message) {
          this.$q.notify({
              message: message,
              position: 'top'
          })
      },
      openEmailForm(row) {
          this.displayEmailForm = true
          this.selectedRow = row
      },
      makeSure(row) {
          this.selectedRowToBeGranted = row.id
          setTimeout(() => {
              this.selectedRowToBeGranted = undefined
          }, 2000)
      },
      grantAdditionalRamps(row) {
          this.grantLoading = true
          new User({id: this.selectedRowToBeGranted}).grant((data) => {
              this.selectedRowToBeGranted = undefined
              this.grantLoading = false
              row['role'] = data
          })
      },
      openIdDocument(row) {
          this.refreshIdDocumentKey += 1
          this.displayIdDocumentDialog = true
          this.selectedRow = row
      },
      openNotes(row) {
          this.refreshNotesKey += 1
          this.displayNotesDialog = true
          this.selectedRow = row
      },
      openImageAttachment(row) {
          this.refreshImageAttachmentKey += 1
          this.displayImageAttachmentDialog = true
          this.selectedRow = row
      },
      profilePhotoStored(url) {
          this.$q.notify({
              message: `The image was saved!`,
              color: 'positive',
              icon: 'fa fa-check'
          })
          this.selectedRow.profile_photo = url
      },
      profilePhotoDeleted() {
          this.$q.notify({
              message: `The image was deleted!`,
              color: 'negative',
              icon: 'fa fa-exclamation-triangle'
          })
          this.selectedRow.profile_photo = null
      },
      openURL
    },
    beforeCreate() {
      if(! this.$auth.can('users.list')){
        this.$router.push({name: 'dashboard'})
      }
    },
    mounted() {
      // once mounted, we need to trigger the initial server data fetch
      if(this.$router.currentRoute.query.q !== undefined && !this.$parent.name) {
          this.filter = this.$router.currentRoute.query.q
      }else if (this.filterByEmail) {
          this.filter = this.filterByEmail
      } else {
          this.all({
              pagination: this.serverPagination,
              filter: this.filter
          })
      }

      if (! this.real_countries.length) {
        this.loading_countries = true
        this.set_countries().then(() => {
            this.loading_countries = false;
        }).catch(() => {this.loading_countries = false})
      }
    },
    components: {
        EmailModal,
        NotesDialog,
        UserDetails,
        BulkEmailModal,
        UserImageDialog,
        SetActionDialog,
        IdDocumentDialog
    }
  }
</script>
